// Wordmark — bubble lowercase with a pink dot.
// Ported from design-canon/project/src/components.jsx → Wordmark
// Animates a 'stumble' wobble on mount + click.

import { useState } from 'react'

export function Wordmark({ size = 92, onClick }: { size?: number; onClick?: () => void }) {
  const letters = 'stumble'.split('')
  const [tick, setTick] = useState(0)

  return (
    <button
      type="button"
      className="wordmark"
      style={{
        fontSize: size,
        display: 'inline-flex',
        lineHeight: 1,
        position: 'relative',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        padding: 0,
        color: 'inherit',
        // font intentionally NOT 'inherit' — the .wordmark CSS class sets
        // font-family: var(--font-display) and that must win.
      }}
      onClick={() => {
        setTick((n) => n + 1)
        onClick?.()
      }}
      aria-label="stumble (tap to stumble)"
    >
      {letters.map((ch, i) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: letters in a fixed 7-char word have no other stable identity; tick re-keys for wobble animation.
          key={`${tick}-${ch}-${i}`}
          className="wm-letter"
          style={{
            display: 'inline-block',
            animationDelay: `${(i * 0.08).toFixed(2)}s`,
            animationDuration: `${(1.6 + (i % 3) * 0.12).toFixed(2)}s`,
          }}
        >
          {ch}
        </span>
      ))}
    </button>
  )
}
